import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AWS from 'aws-sdk';

const S3_BUCKET = "car-tool" || 'YOUR_BUCKET_NAME';
const REGION = "eu-north-1" || 'YOUR_REGION';

AWS.config.update({
  accessKeyId: 'AKIA2T56GOWBPOMMIDXL' || 'YOUR_ACCESS_KEY',
  secretAccessKey: 'yB5+ohqn0Jo8uIuSVITISkA68PWOMB88PuO/Vt6/' || 'YOUR_SECRET_ACCESS_KEY',
});

const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION
});

const UploadPhoto = ({ onUploadSuccess, imageUrl }) => {
  const [uploading, setUploading] = useState(false);

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    if (file) {
      uploadFile(file);
    }
  };

  const uploadFile = (file) => {
    setUploading(true);
    const fileKey = `car-images/${Date.now()}-${file.name}`;
    const params = {
      Body: file,
      Bucket: S3_BUCKET,
      Key: fileKey,
      ContentType: file.type
    };

    myBucket.putObject(params)
      .on('httpUploadProgress', (evt) => {
        console.log('Uploading: ', Math.round((evt.loaded / evt.total) * 100) + '%');
      })
      .send((err, data) => {
        setUploading(false);
        if (err) {
          console.log(err);
          alert('Failed to upload image.');
        } else {
          console.log('Upload successful');
          const imageUrl = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${fileKey}`;
          if (onUploadSuccess) {
            onUploadSuccess(imageUrl);
          }
        }
      });
  };

  return (
    <div>
      <Button
        variant="outlined"
        component="label"
        startIcon={<CloudUploadIcon />}
        fullWidth
        disabled={uploading}
      >
        {uploading ? 'Uploading...' : 'Upload Car Image'}
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={handleFileInput}
        />
      </Button>
      {imageUrl && (
        <Box sx={{ mt: 1 }}>
          <img 
            src={imageUrl} 
            alt="Car" 
            style={{ width: '100%', maxHeight: '100px', objectFit: 'cover' }}
          />
        </Box>
      )}
    </div>
  );
};

export default UploadPhoto;
